export const RING_TONE_SOUND_ID = 'RING_TONE_SOUND_ID';
export const BEEP_TONE_SOUND_ID = 'BEEP_TONE_SOUND_ID';
export const UPLDATE_PHONE_NUMBER_AND_PIN = 'UPLDATE_PHONE_NUMBER_AND_PIN';